import React, { Component } from "react";
import axios from "axios";
import domain from ".././../../../domain";

import { Input, Button } from "mdbreact";

import { Row, Col, Card, CardBody } from "mdbreact";

//import { Icon,Row} from 'react-materialize'
class AddTrainee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      designation: "",
      organization: "",
      city: "",
      tstate: "",
      address: " ",
      department: "",
      email: "",
      mobile: "",
      gender: " ",
      course: " ",
      loading: true,
      error: "",
      data: null,
      course_id: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    console.log(e.target.name + "" + e.target.value);
  };

  componentDidMount() {
    axios
      .get(`${domain.DBServer}/fetch-course-status`)
      .then((result) => {
        console.log(result);
        this.setState({
          data: result.data,
          course_id: result.data[0].course_id,
          loading: false,
          error: false,
        });
      })
      .catch((error) => {
        console.error("error: ", error);
        this.setState({
          error: `${error}`,
          loading: true,
        });
      });
  }

  addParticipant(newParticipant) {
    console.log(newParticipant);
    axios
      .request({
        method: "post",
        url: `${domain.DBServer}/add-trainee`,
        data: newParticipant,
      })
      .then((response) => {
        console.log(response);
        //console.log(response)
        const { err, success, msg } = response.data;

        //console.log(success+msg+err)
        console.log(success);
        console.log(err);

        if (success) {
          console.log("if");
          alert(msg);
          //console.log(this)
          this.props.history.push(`/view-trainees/${this.state.course_id}`);
        } else {
          console.log("else");
          alert(msg);

          document.getElementsByClassName("mobileField")[0].focus();
          return false;
        }
      })
      .catch((err) => console.log(err));
  }

  onSubmit(e) {
    e.preventDefault();
    console.log(this.state.course);
    const newParticipant = {
      TraineeName: this.state.name,
      City: this.state.city,
      address: this.state.address,
      Designation: this.state.designation,
      Organization: this.state.organization,
      State: this.state.tstate,
      Email: this.state.email,
      Mobile: this.state.mobile,
      Department: this.state.department,
      course_id: this.state.course_id,
      gender: this.state.gender,
    };
    let r = window.confirm("Check once again the details before submitting");
    if (r) {
      this.addParticipant(newParticipant);
    } else {
      return false;
    }
  }

  intialValues = (e) => {
    //  alert(e.target.name)
    this.setState({
      name: "",
      designation: "",
      organization: "",
      city: "",
      tstate: "",
      address: " ",
      department: "",
      email: "",
      mobile: "",
      gender: " ",
      course: " ",
    });
  };

  render() {
    const { loading, error, data } = this.state;
    if (loading) {
      return <p>Loading ...</p>;
    }
    if (error) {
      return (
        <h4>
          There was no ongoing courses .
          {/* <button onClick={this.loadData}>Try again</button> */}
        </h4>
      );
    }
    return (
      <div>
        <br />
        <Row className="justify-content-md-center">
          <Col md="6">
            <Card>
              <CardBody>
                <h1 style={{ textAlign: "center", color: "blue" }}>
                  Add Trainee
                </h1>

                <form onSubmit={this.onSubmit.bind(this)}>
                  <div className="row">
                    <label for="course">Choose Course</label>
                    <select
                      className="form-control"
                      id="course_id"
                      name="course_id"
                      selected={this.state.course_id}
                      value={this.state.course_id}
                      onChange={this.handleInputChange}
                    >
                      {data &&
                        data.map((course) => (
                          <option
                            key={course.course_id}
                            value={course.course_id}
                          >
                            {course.title}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <Input
                        label="Trainee Name"
                        value={this.state.name}
                        id="name"
                        name="name"
                        group
                        type="text"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label="Organization"
                        value={this.state.organization}
                        id="organization"
                        name="organization"
                        group
                        type="text"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label="Designation"
                        value={this.state.designation}
                        id="designation"
                        name="designation"
                        group
                        type="text"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <Input
                        type="textarea"
                        label="Address"
                        value={this.state.address}
                        id="address"
                        name="address"
                        group
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label="City"
                        id="city"
                        name="city"
                        value={this.state.city}
                        group
                        type="text"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label="State"
                        id="tstate"
                        name="tstate"
                        value={this.state.tstate}
                        group
                        type="text"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <Input
                        label="Email"
                        id="email"
                        name="email"
                        value={this.state.email}
                        group
                        type="email"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label="Mobile"
                        id="tel"
                        className="mobileField"
                        value={this.state.mobile}
                        name="mobile"
                        group
                        type="tel"
                        validate
                        pattern="[0-9]{10}"
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label="Department"
                        id="department"
                        value={this.state.department}
                        name="department"
                        group
                        type="text"
                        validate
                        onChange={this.handleInputChange}
                        required="required"
                      />
                    </div>
                  </div>
                  <fieldset className="form-group">
                    <div className="row">
                      <legend className="col-form-label col-sm-2 pt-0">
                        Gender
                      </legend>
                      <div className="col-sm-10">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="gender1"
                            value="Male"
                            onChange={this.handleInputChange}
                            required
                          />
                          <label className="form-check-label" htmlFor="gender1">
                            Male
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="gender2"
                            value="Female"
                            onChange={this.handleInputChange}
                            required
                          />
                          <label className="form-check-label" htmlFor="gender2">
                            Female
                          </label>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <Button type="submit">Save</Button> &nbsp;&nbsp;
                  <Button type="reset" name="clear" onClick={this.intialValues}>
                    Clear
                  </Button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default AddTrainee;
